<template>
  <div id="app">
    <div :class="this.widthwin>1000?'containerwap':'widthc'">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {},
  data(){
    return{
      widthwin:""
    }
  },
  mounted(){
     this.widthwin = document.body.clientWidth || document.documentElement.clientWidth;
    console.log(this.widthwin)
  }
};
</script>
<style lang="scss" scoped>
#app {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
  .widthc{
    width: 1404px;
  }
}
</style>
